import { ApiKeyRow } from "./ApiKeyRow";
import { ApiKeysListProps, ServicesType } from "./types";

export const ApiKeysList: React.FC<ApiKeysListProps> = ({
  apiKeys,
  websiteData,
  isWebsiteLoading,
  setHeurekaModalOpen,
  setZboziModalOpen,
  setSpolehliveRecenzeModalOpen,
  setGoogleReviewsOpen,
  setTrustPilotModalOpen,
  statusSuccess,
  getStringStatus,
  t,
  classes,
}) => {
  const handleModalOpen = (type: ServicesType) => {
    const modalSetters = {
      heureka: setHeurekaModalOpen,
      zbozi: setZboziModalOpen,
      spolehliveRecenze: setSpolehliveRecenzeModalOpen,
      googleReviews: setGoogleReviewsOpen,
      trustPilot: setTrustPilotModalOpen,
    };
    modalSetters[type](true);
  };

  return (
    <>
      {apiKeys.map(apiKey => (
        <ApiKeyRow
          key={apiKey.apiKeyField}
          apiKey={apiKey}
          websiteData={websiteData}
          isWebsiteLoading={isWebsiteLoading}
          onModalOpen={handleModalOpen}
          statusSuccess={statusSuccess}
          getStringStatus={getStringStatus}
          onlyUsaVisible={apiKey.onlyUsaVisible}
          t={t}
          classes={classes}
        />
      ))}
    </>
  );
};
